import { styled } from '@mui/material'

export const Root = styled('div')`
  padding: 12px 0 0;
  width: 100%;
`
